import React from 'react';
import { StepContentLayout, StepContentInner, FlowDot, FlowDotItem, FlowDotWord, FlowDotLine } from './style';

interface StepContentProps {
  currentStep: number; // 現在のステップ（0から始まるインデックス）
}

const StepContent: React.FC<StepContentProps> = ({ currentStep }) => {
  const steps = [
    { id: 'shop', label: '店舗選択' },
    { id: 'program', label: 'プログラム・日時選択' },
    { id: 'account', label: 'アカウント登録' },
    { id: 'complete', label: '予約完了' },
  ];

  // 線の幅を取得する関数
  const getLineWidthClass = (index: number): 'width97' | 'width118' | 'width140' | '' => {
    if (index === 0) return 'width118';
    if (index === 1) return 'width140';
    if (index === 2) return 'width97';
    return '';
  };

  return (
    <StepContentLayout>
      <StepContentInner>
        <FlowDot>
          {steps.map((step, index) => (
            <React.Fragment key={step.id}>
              <FlowDotItem isActive={index <= currentStep - 1}>
                <FlowDotWord>{step.label}</FlowDotWord>
              </FlowDotItem>
              {index < steps.length - 1 && (
                <FlowDotLine isActive={index < currentStep - 1} widthClass={getLineWidthClass(index)} />
              )}
            </React.Fragment>
          ))}
        </FlowDot>
      </StepContentInner>
    </StepContentLayout>
  );
};

export default StepContent;
